import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ACCEPTABLE_LOGO_FORMATS, MAX_LOGO_SIZE, PROVIDER_ADMIN } from '../../config/app_config';
import HomeIndex from './HomeIndex';
import { listUsers, uploadCompanyLogo, removeCompanyLogo } from '../../actions/user';
import { storeWithExpiration } from '../../utils/common';
import { openDialog, closeDialog } from '../../actions/dialog';

export class HomeIndexContainer extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    authentication: PropTypes.object.isRequired,
    closeDialogAction: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    isProviderAdmin: PropTypes.bool.isRequired,
    listUsersAction: PropTypes.func.isRequired,
    openDialogAction: PropTypes.func.isRequired,
    removeCompanyLogoAction: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    users: PropTypes.object.isRequired,
    uploadCompanyLogoAction: PropTypes.func.isRequired,
    viewOnlyAccount: PropTypes.object.isRequired,
  };

  state = {
    primaryContact: {},
    imgFile: {},
  };

  componentWillMount = () => {
    const { user, viewOnlyAccount, listUsersAction } = this.props;
    const token = storeWithExpiration.get('token');
    let { accountId } = user;
    if (accountId === 1 && !(viewOnlyAccount.id === 0)) {
      accountId = viewOnlyAccount.id;
    }
    listUsersAction(accountId, token);
  };

  componentWillReceiveProps = nextProps => {
    const { users } = nextProps;
    users.map(contact => {
      if (contact.isPrimary) {
        this.setState({ primaryContact: contact });
      }
      return contact;
    });
  };

  clearFileFunction = () => {
    this.setState({ imgFile: {} });
  };

  handleOnDrop = files => {
    const fileType =
      files[0] !== undefined && files[0].name.length >= 4
        ? files[0].name.substring(files[0].name.length - 4).toLowerCase()
        : '';
    const isAcceptableSize = files[0].size <= MAX_LOGO_SIZE;

    if (ACCEPTABLE_LOGO_FORMATS.indexOf(fileType) < 0) {
      const message = 'Incorrect file type. Please choose a acceptable file type.';
      this.setState({ imgFile: { message } });
    } else if (!isAcceptableSize) {
      const message = 'Incorrect file size. Please be sure your file is less than 5Mb.';
      this.setState({ imgFile: { message } });
    } else {
      this.setState({ imgFile: files[0] });
    }
  };

  handleLogoUpload = () => {
    const { account, closeDialogAction, dialog, uploadCompanyLogoAction } = this.props;
    const { imgFile } = this.state;
    const token = storeWithExpiration.get('token');
    uploadCompanyLogoAction(account.id, imgFile, token);
    closeDialogAction(dialog.id);
    this.setState({ imgFile: {} });
  };

  removeCompanyLogoFunction = () => {
    const { account, closeDialogAction, dialog, removeCompanyLogoAction } = this.props;
    const token = storeWithExpiration.get('token');
    removeCompanyLogoAction(account.id, token);
    closeDialogAction(dialog.id);
  };

  toggleDialog = id => {
    const { dialog, openDialogAction, closeDialogAction } = this.props;
    if (dialog.show) {
      closeDialogAction(id);
      this.setState({ imgFile: {} });
    } else {
      openDialogAction(id);
    }
  };

  render() {
    const { account, authentication, dialog, isProviderAdmin } = this.props;
    const { imgFile, primaryContact } = this.state;

    return (
      <HomeIndex
        account={account}
        authentication={authentication}
        clearFileFunction={this.clearFileFunction}
        dialog={dialog}
        handleOnDrop={this.handleOnDrop}
        handleLogoUpload={this.handleLogoUpload}
        imgFile={imgFile}
        isProviderAdmin={isProviderAdmin}
        primaryContact={primaryContact}
        removeCompanyLogoFunction={this.removeCompanyLogoFunction}
        toggleDialogFunction={this.toggleDialog}
      />
    );
  }
}

function mapStateToProps(state) {
  const { authentication, dialog, account, user, userList, superadmin } = state;
  const isProviderAdmin = user.get('userTypeId') === PROVIDER_ADMIN;
  const viewOnlyAccount = superadmin.get('viewOnlyAccount');
  const users = userList.get('users');
  return {
    authentication,
    account,
    dialog,
    isProviderAdmin,
    user,
    users,
    viewOnlyAccount,
  };
}

export default connect(mapStateToProps, {
  openDialogAction: openDialog,
  closeDialogAction: closeDialog,
  listUsersAction: listUsers,
  removeCompanyLogoAction: removeCompanyLogo,
  uploadCompanyLogoAction: uploadCompanyLogo,
})(HomeIndexContainer);
